<template>
    <div :class="['select-wrapper', {error: error }]">
        <input
            :type="inputtype"
            :placeholder="placeholdertext"
            :value="value"
            @input="update">
    </div>
</template>

<script>
    export default {
        name: 'OSJInput',
        props: {
            inputtype: {
                type: String,
                default: 'text'
            },
            placeholdertext: String,
            error: Boolean,
            value: String
        },
        methods : {
            update( e ){
                this.$emit( "input", e.target.value )
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";

    .select-wrapper{
        background-color: white;
        border: 1px solid $pale-gray;
        display: block;
        margin-bottom: 1rem;
        text-align: left;
        cursor: pointer;
        position: relative;
        border-radius: $radius;
        overflow: hidden;
        
        &.error {
            border-color: $red;
            background-color: lighten($red, 55%)
        }

        select, input{
            background: transparent;
            font-size: 1.2rem;
            border-radius: 0;
            border: none;
            width: 100%;
            max-width: 100%;
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;
            padding: 1rem 1.5rem;

            &:focus{
                background-color: white;
            }
        }

        &-search input{
            background-image: url( "~@/assets/mag.svg" );
            background-position: right 1.5rem center;
            background-repeat: no-repeat;
            background-size: auto 50%;
        }
    }
</style>